import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { WebSiteSchema, WebPageSchema, FAQPageSchema, OrganizationSchema } from '@/components/feature/SchemaOrg';
import { faqItems } from '@/mocks/homeData';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import ArticleSection from './components/ArticleSection';
import MemberSection from './components/MemberSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        name="红桃视频官网 - 官方正版视频平台入口"
        description="红桃视频官网是您访问红桃视频的唯一官方正版入口，提供高清视频播放、最新影视资源、会员专属内容及安全稳定的观看体验。立即访问红桃视频官网，享受极致流畅的视频娱乐服务。"
        url="https://hongtaovideo.com/"
      />
      <FAQPageSchema items={faqItems.map((item) => ({ question: item.question, answer: item.answer }))} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <MemberSection />
        <ArticleSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}